import React from 'react';
import MaterialTable from '@material-table/core';
import AddIcon from '@mui/icons-material/Add';
import { Box, Fab, Paper, Chip } from '@mui/material';
import api from '../../services/api';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { materialTableLocalization } from '../../config';
import DialogoPrograma from './DialogoPrograma';

const Programa = () => {
  const startLoading = useStoreActions((actions) => actions.nav.startLoading);
  const stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  const user = useStoreState((state) => state.auth.user);

  const [rows, setRows] = React.useState([]);
  const [openDialogo, setOpenDialogo] = React.useState(false);
  const [programaSelecionado, setProgramaSelecionado] = React.useState(null);

  const loadProgramas = async () => {
    startLoading();
    try {
      const data = (await api.http.get('/programas')).data;
      setRows(data);
    } catch (err) {
      stopLoading({
        message: err.toString(),
        severity: 'error',
      });
    }
    stopLoading();
  };

  React.useEffect(() => {
    loadProgramas();
  }, []);

  const onRowClick = (event, rowData) => {
    setProgramaSelecionado(rowData);
    setOpenDialogo(true);
  };

  const onCloseDialogo = (reload = false) => {
    setProgramaSelecionado(null);
    setOpenDialogo(false);
    if (reload) {
      loadProgramas();
    }
  };

  // proteção superAdmin
  if (user.roleId !== 'superAdmin') {
    return <Box sx={{ p: 4 }}>Acesso restrito ao administrador.</Box>;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <DialogoPrograma
        open={openDialogo}
        onClose={onCloseDialogo}
        programa={programaSelecionado}
      />
      <Paper variant="outlined" className="center-box" sx={{ width: '100%', my: 3 }}>
        <MaterialTable
          columns={[
            { field: 'nome', title: 'Nome do Programa' },
            {
              title: 'Funcionários',
              render: (row) =>
                row.num_funcs_rule && row.num_funcs_value
                  ? `${row.num_funcs_rule === '>' ? 'Maior que' : 'Menor que'} ${row.num_funcs_value} empregados`
                  : '-',
            },
            {
              title: 'Gastos de energia',
              render: (row) =>
                row.energia_rule && row.energia_value
                  ? `${row.energia_rule === '>' ? 'Maior que' : 'Menor que'} ${row.energia_value} R$/mês`
                  : '-',
            },
            {
              title: 'Potencial de emissão',
              render: (row) =>
                row.emissoes_rule && row.emissoes_value
                  ? `${row.emissoes_rule === '>' ? 'Maior que' : 'Menor que'} ${row.emissoes_value} tCO2e/mês`
                  : '-',
            },
            {
              title: 'Status',
              render: (row) =>
                row.active ? (
                  <Chip label="Ativo" color="success" size="small" />
                ) : (
                  <Chip label="Inativo" color="error" size="small" />
                ),
            },
          ]}
          data={rows}
          title="Programas"
          onRowClick={onRowClick}
          localization={materialTableLocalization}
          options={{
            rowStyle: (rowData) => ({
              backgroundColor: rowData.active ? 'inherit' : '#f5f5f5',
            }),
          }}
        />
      </Paper>
      <Fab color="primary" aria-label="novo programa" onClick={() => setOpenDialogo(true)}>
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default Programa;
